import { EVENT_TYPE, IMAGE_LOCAL } from '@/common/constants';
import CommonModal from '@/components/Modals/CommonModal';
import {
  useAppCommon,
  useGenerateClipart,
  useModal,
  usePrintBackgroundMenu
} from '@/hooks';
import ResultItem from '../ResultItem';
import ConfirmAction from '@/containers/Modals/ConfirmAction';
import ExampleItem from '../ExampleItem';

export default {
  components: {
    CommonModal,
    ResultItem,
    ConfirmAction,
    ExampleItem
  },
  data() {
    const exampleItems = [
      {
        thumbnail: IMAGE_LOCAL.CLIPART_AI_01,
        des: 'A colorful cartoon school house',
        isSingle: false
      },
      {
        thumbnail: IMAGE_LOCAL.CLIPART_AI_02,
        des: 'A rough sketch of a school house',
        isSingle: false
      },
      {
        thumbnail: IMAGE_LOCAL.CLIPART_AI_03,
        des: 'A black and white school house',
        isSingle: false
      }
    ];
    return {
      exampleItems,
      selectedItem: [],
      describe: null,
      desText: null,
      results: null,
      isShowResults: false,
      isShowSuccessModal: false,
      isOpen: true,
      generatedCliparts: null,
      isLoading: false
    };
  },
  setup() {
    const { toggleModal } = useModal();
    const { currentSheet } = usePrintBackgroundMenu();
    const { generateClipart, saveGeneratedCLipart } = useGenerateClipart();
    const { generalInfo } = useAppCommon();

    return {
      toggleModal,
      currentSheet,
      generateClipart,
      generalInfo,
      saveGeneratedCLipart
    };
  },
  computed: {
    isDisableSelect() {
      return !this.selectedItem.length;
    },
    isDisabledGenBtn() {
      return !this.describe;
    }
  },
  methods: {
    onCancel() {
      this.isShowSuccessModal = false;
      this.toggleModal({
        isOpenModal: false
      });
    },
    onSelect() {
      this.isOpen = false;
      this.isShowSuccessModal = true;
    },
    async onGenerate() {
      this.isLoading = true;
      this.isShowResults = false;
      this.selectedItem = [];
      this.results = await this.generateClipart({
        describe: this.describe,
        communityId: this.generalInfo.communityId
      });
      this.desText = this.describe;
      this.describe = null;
      this.isShowResults = true;
      this.isLoading = false;
    },
    onSelectedItem(value) {
      const index = this.selectedItem.findIndex(item => item === value);
      if (index < 0) {
        this.selectedItem.push(value);
      } else {
        this.selectedItem.splice(index, 1);
      }
    },
    async onSaveOnly() {
      this.generatedCliparts = await this.saveGeneratedCLipart(
        this.selectedItem,
        this.results.id
      );
      this.onCancel();
    },
    async onSaveAndPlace() {
      await this.onSaveOnly();
      if (!this.generatedCliparts) {
        return;
      }
      this.$root.$emit(EVENT_TYPE.ADD_CLIPARTS, this.generatedCliparts);
    }
  }
};
